import React from 'react';
import { useSiteContent } from '../content/SiteContentProvider';
import { getText } from '../content/cmsAccess';

const GRID_CELLS = Array.from({ length: 520 });

export default function SocialGridSection() {
  const { content } = useSiteContent();
  const social = content.pages.home.social;

  return (
    <section className="relative w-full bg-white pt-[calc(5vw+7rem)] pb-32 lg:pt-[calc(5vw+10rem)] lg:pb-44 px-6 lg:px-12 flex flex-col items-center justify-center z-10 overflow-hidden min-h-[720px] -mt-[5vw]">
      <div
        className="absolute inset-0 z-0 grid"
        style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(64px, 1fr))', gridAutoRows: '64px' }}
      >
        {GRID_CELLS.map((_, index) => (
          <div
            key={index}
            className="border-r border-b border-black/[0.045] bg-transparent hover:shadow-[inset_0_0_0_2px_rgba(26,27,36,0.2)] relative hover:z-10 transition-shadow duration-[1.2s] hover:duration-0"
          />
        ))}
      </div>

      <div className="ambient-breathe absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[15vw] font-black leading-none text-[#1b1c26] pointer-events-none select-none z-0 flex items-center justify-center opacity-5 whitespace-nowrap">
        SOCIAL
      </div>

      <div className="relative z-10 flex flex-col items-center text-center pointer-events-none max-w-5xl">
        <h2 className="text-3xl md:text-5xl font-black text-[#1a1b24] uppercase tracking-tighter mb-8 pointer-events-none">
          {getText(social, 'title', 'SUIVEZ-NOUS SUR NOS RÉSEAUX SOCIAUX')}
        </h2>

        <div className="flex flex-wrap items-center justify-center gap-5 pointer-events-auto">
          <a
            href={getText(social, 'instagramHref', 'https://www.instagram.com/gameside.caen/')}
            target="_blank"
            rel="noreferrer"
            className="social-btn-instagram"
            aria-label={`${getText(social, 'instagramLabel', 'Instagram')} Gameside Caen`}
          >
            <span className="svgContainer">
              <svg fill="white" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
              </svg>
            </span>
            <span className="BG" aria-hidden="true" />
          </a>
          <a
            href={getText(social, 'facebookHref', 'https://www.facebook.com/gameside.caen/')}
            target="_blank"
            rel="noreferrer"
            className="social-btn-facebook"
            aria-label={`${getText(social, 'facebookLabel', 'Facebook')} Gameside Caen`}
          >
            <span className="svgContainer">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path
                  d="M12 2.03998C6.5 2.03998 2 6.52998 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.84998C10.44 7.33998 11.93 5.95998 14.22 5.95998C15.31 5.95998 16.45 6.14998 16.45 6.14998V8.61998H15.19C13.95 8.61998 13.56 9.38998 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96C15.9164 21.5878 18.0622 20.3855 19.6099 18.57C21.1576 16.7546 22.0054 14.4456 22 12.06C22 6.52998 17.5 2.03998 12 2.03998Z"
                  fill="#ffffff"
                />
              </svg>
            </span>
            <span className="BG" aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
}
